"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

var SvgArrowUpLeft = function SvgArrowUpLeft(props) {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M27 17a1 1 0 010 2h-6.585l10.292 10.293a1 1 0 01-1.414 1.414L19 20.415V27a1 1 0 01-2 0v-9.018c0-.024.002-.048.004-.071L17 18a1.008 1.008 0 01.213-.617c.05-.063.107-.12.17-.17l-.09.08a1.008 1.008 0 01.689-.293H27z",
    id: "arrow-up-left_svg__a"
  }));
};

var _default = SvgArrowUpLeft;
exports.default = _default;